module.exports = __webpack_public_path__ + "img/98e63d2.svg";